import Vue from "vue";
import Router from "vue-router";
import store from "../store/index"

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Start",
      component: () => import("../views/Login.vue"),
    },
    {
      path: "/Home",
      name: "Home",
      component: () => import("../views/Home.vue"),
    },
    {
      path: "/newmemory",
      name: "newmemory",
      component: () => import("../views/NewMemory.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/Books",
      name: "books",
      component: () => import("../views/Books.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/Memoryreader",
      name: "memoryreader",
      component: () => import("../views/MemoryReader.vue"),
      beforeEnter : guardMyroute,
      props: true,
    },
    {
      path: "/Circles",
      name: "circles",
      component: () => import("../views/Circles.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/CircleList",
      name: "cirecllist",
      component: () => import("../views/CircleList.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/Login",
      name: "login",
      component: () => import("../views/Login.vue"),
      props: true,
    },
    {
      path: "/forgot",
      name: "forgot",
      component: () => import("../views/Forgot.vue"),
    },
    {
      path: "/quickconnect",
      name: "quickconnect",
      component: () => import("../views/QuickConnect.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/quickconnectmanagement",
      name: "quickconnectmanagement",
      component: () => import("../views/QuickConnectManagement.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/Profile",
      name: "profile",
      component: () => import("../views/Profile.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/InvitationRegistration",
      name: "invitationregistration",
      component: () => import("../views/InvitationRegistration.vue"),
      props: true,
    },
    {
      path: "/RegistrationConfirmation",
      name: "RegistrationConfirmation",
      component: () => import("../views/RegistrationConfirmation.vue"),
      props: true,
    },
    {
      path: "/userprofile",
      name: "userprofile",
      component: () => import("../views/UserProfile.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/invitation",
      name: "Invitation",
      component: () => import("../views/Invitation.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/admininvitation",
      name: "admininvitation",
      component: () => import("../views/AdminInvitation.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/acceptinvitation/:invitationID",
      name: "acceptinvitation",
      component: () => import("../views/Acceptinvitation.vue"),
    },

    {
      path: "/FreeDays",
      name: "FreeDays",
      component: () => import("../views/FreeDays.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/CharterSuggestions",
      name: "CharterSuggestions",
      component: () => import("../views/CharterSuggestions.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/about",
      name: "about",
      component: () => import("../views/About.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/policies",
      name: "policies",
      component: () => import("../views/Policies.vue"),
    },
    {
      path: "/rules",
      name: "rules",
      component: () => import("../views/Rules.vue"),
    },
    {
      path: "/AdminPage",
      name: "adminpage",
      component: () => import("../views/AdminPage.vue"),
    },
    {
      path: "/AdminMessage",
      name: "adminmessage",
      component: () => import("../views/AdminMessage.vue"),
    },
    {
      path: "/credits",
      name: "credits",
      component: () => import("../views/Credits.vue"),
      beforeEnter : guardMyroute
    },
    {
      path: "/newpassword",
      name: "newpassword",
      component: () => import("../views/NewPassword.vue"),
    },
  ],
       scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
         if (to.hash) {
            return { selector: to.hash };
        }
    return { x: 0, y: 0 }
  },
  
});

function guardMyroute(to, from, next)
{
//this is just an example. You will have to find a better or 
// centralised way to handle you localstorage data handling 
if(store.state.loginState === true)
 {
  next(); // allow to enter route
 } 
 else
 {
  next('/login'); // go to '/login';
 }
}
